<template>
  <div>
    <div class="d-flex gap-2">
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Pesquisar"
        single-line
        dense
        hide-details
        outlined
      />
      <v-btn @click="addTechnician" color="primary">
        <v-icon left>mdi-plus</v-icon>
        Técnico
      </v-btn>
    </div>
    <v-data-table
      :loading="loading"
      :items="platform.technicians"
      :headers="headers"
      :search="search"
      class="elevation-0"
    >
      <template v-slot:item.name="{ item }">
        <base-avatar
          v-if="!!item.User.name"
          :src="item.User.photo"
          :seed="item.User.id"
          :size="35"
        />
        <v-avatar v-else size="35">
          <v-icon large>mdi-account-question</v-icon>
        </v-avatar>
        <span class="ml-2">{{ item.User.name || "Conta não criada" }}</span>
      </template>
      <template v-slot:item.permissions="{ item }">
        <span class="text--disabled caption">
          <v-icon small> mdi-shield-lock </v-icon>
          {{ item.permissions.length }}
          {{ item.permissions.length != 1 ? "permissões" : "permissão" }}
        </span>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" @click="edit(item)"> mdi-pencil </v-icon>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: "PlatformTechniciansManagement",
  props: {
    platform: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      headers: [
        { text: "Nome", value: "name" },
        { text: "Permissões", value: "permissions" },
        { text: "Ações", value: "actions", sortable: false },
      ],
      search: "",
    };
  },
  methods: {
    addTechnician() {
      this.$root.$emit("technician-member-modal", {
        platform: this.platform,
        technician: null,
      });
    },
    edit(item) {
      this.$root.$emit("technician-member-modal", {
        platform: this.platform,
        technician: {
          ...item.User,
          permissions: item.permissions.map((p) => `${p}`),
        },
      });
    },
  },
};
</script>
